export default __webpack_public_path__ + "static/media/linkedin.033b1683.svg";